var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNutritionTargetsEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 73,
    viewBox: "0 0 74 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 73,
    height: 73,
    rx: 36.5,
    fill: "#F2F5FA",
    fillOpacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 8,
    width: 57,
    height: 57,
    rx: 28.5,
    fill: "#F2F5FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2839 34.6603C51.1249 30.5547 47.0106 19.0902 39.7695 24.6649C34.6014 17.2306 27.1389 25.7961 37.2839 34.6603Z",
    fill: "#7E898F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5399 35.5506C28.447 23.482 18.9009 30.9412 26.3636 36.209C20.9364 43.4523 31.2845 48.0204 36.5399 35.5506Z",
    fill: "#7E898F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7396 36.9335C33.0043 43.2254 37.1625 51.1663 37.1625 51.1663L40.275 49.908C38.4075 47.8107 35.1902 42.4997 36.7396 36.9335Z",
    fill: "#7E898F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5077 35.7148C37.9098 50.2883 49.9269 49.1877 46.4378 40.6904C54.8673 37.5333 48.5732 28.0577 37.5077 35.7148Z",
    fill: "#7E898F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNutritionTargetsEmpty);
export default __webpack_public_path__ + "static/media/NutritionTargetsEmpty.7761969356dc6006d3cd35cca61d06c1.svg";
export { ForwardRef as ReactComponent };